<div id="acom">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="inner-card">
          <h4 class="card-title">Maharana Pratap Public School, Sector 7, Kurukshetra</h4>
          <div class="card-body text-justify">
            <h5>Fee Structure for the Session 2025-26</h5>
            <hr class="pb-1 rounded">
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th scope="col">Classes</th>
                  <!-- <th scope="col">Toddler’s Club</th> -->
                  <th scope="col">Nursery, LKG & UKG</th>
                  <th scope="col">I to V</th>
                  <th scope="col">VI to VIII</th>
                  <th scope="col">IX & X</th>
                  <th scope="col">XI & XII (Commerce & Arts)</th>
                  <th scope="col">XI & XII (Science)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">Admission Fee only for new students</th>
                  <!-- <td>5000</td> -->
                  <td>5000</td>
                  <td>5000</td>
                  <td>5000</td>
                  <td>5000</td>
                  <td>5000</td>
                  <td>5000</td>
                </tr>
                <tr>
                  <th scope="row">Tuition Fee(2025-26)</th>
                  <!-- <td>2500</td> -->
                  <td>2850</td>
                  <td>3400</td>
                  <td>3750</td>
                  <td>3950</td>
                  <td>4050</td>
                  <td>4100</td>
                </tr>

              </tbody>
            </table>
            <!-- <table class="table table-bordered table-hover">
                            
                            <tbody>
                              <tr>
                                <th scope="row">Admission Fee</th>
                                <td>1400.00</td>
                              </tr>
                              
                            </tbody>
                          </table>
                       
                          <h5>FOR ALL THE STUDENTS</h5>
                          <hr class="pb-1 rounded">
                          <h5>ANNUAL CHARGES</h5>
                          <table class="table table-bordered table-hover">
                           
                            <tbody>
                              <tr>
                                <th scope="row">Toddlers’ Club to K.G.</th>
                                <td> 6000.00</td>
                              </tr>
                              <tr>
                                <th scope="row">I to VIII</th>
                                <td>7200.00</td>
                              </tr>
                              
                              <tr>
                                <th scope="row">IX &X</th>
                                <td>7500.00</td>
                              </tr>
                              <tr>
                                <th scope="row">XI & XII</th>
                                <td>7800.00</td>
                              </tr>
                              <tr>
                                <th scope="row">School Day Book</th>
                                <td>50.00</td>
                              </tr>
                            </tbody>
                          </table>

                          <h5>MONTHLY TUITION FEE</h5>
                          <table class="table table-bordered table-hover">
                           
                            <tbody>
                              <tr>
                                <th scope="row">Toddlers’ Club</th>
                                <td> 1800.00</td>
                              </tr>
                              <tr>
                                <th scope="row">Nursery & K.G.</th>
                                <td>2000.00</td>
                              </tr>
                              
                              <tr>
                                <th scope="row">I to IV</th>
                                <td>2400.00</td>
                              </tr>
                              <tr>
                                <th scope="row">V to VIII</th>
                                <td>2700.00</td>
                              </tr>
                              <tr>
                                <th scope="row">IX to X</th>
                                <td>2900.00</td>
                              </tr>
                              <tr>
                                <th scope="row">XI & XII (Commerce)</th>
                                <td>2950.00</td>
                              </tr>
                              <tr>
                                <th scope="row">XI & XII (Science)</th>
                                <td>3000.00</td>
                              </tr>
                            </tbody>
                          </table>
                          <h5>SCHOOL FEES TO BE PAID IN 6 INSTALMENTS IN ANY OF THE BANKS AUTHORISED BY THE SCHOOL</h5>
                          <hr class="pb-1 rounded">
                          <h5>SCHEDULE FOR DEPOSITING THE FEES</h5>
                          <p class="inner-lead colorYellow">NOTE: New Admissions are required to deposit the first fee instalment at the school office counter through cash.</p>
                          <h5>Instalment</h5>
                          <table class="table table-bordered table-hover">
                           
                            <tbody>
                              <tr>
                                <th scope="row">First</th>
                                <td> April (including Annual Charges)</td>
                              </tr>
                              <tr>
                                <th scope="row">Second</th>
                                <td> May & June (misc. charges of May only) -- May 15, 2021 </td>
                              </tr>
                              
                              <tr>
                                <th scope="row">Third</th>
                                <td>July & Aug -- July  15, 2021</td>
                              </tr>
                              <tr>
                                <th scope="row">Fourth</th>
                                <td> Sept & Oct	-- Sept 15, 2021</td>
                              </tr>
                              <tr>
                                <th scope="row">Fifth</th>
                                <td>Nov & Dec -- Nov 15, 2021</td>
                              </tr>
                              <tr>
                                <th scope="row">Sixth</th>
                                <td>Jan, Feb & March -- Jan   15, 2022</td>
                              </tr>
                            </tbody>
                          </table>
                          <br><br>
                          <h5>WITHDRAWALS</h5>
                          <hr class="pb-1 rounded">
                          <ol>
                              <li>
                                  <p class="inner-lead">Students can be withdrawn from the school by giving one month's notice .
                                       In the absence of such a notice , one month's fee will be charged .
                                       No transfer certificate will be issued until all the dues are cleared .</p>
                              </li>
                              <li>
                                  <p class="inner-lead">If the result is poor consistently for two years , the student can be asked to leave the school . </p>
                              </li>
                              <li>
                                  <p class="inner-lead"> The school authorities reserve the right to dismiss those students who fail to maintain the discipline of the school.</p>
                              </li>
                          </ol> -->
          </div>
          <!-- <h4 class="card-title">Maharana Pratap Public School, City Section, Kurukshetra</h4>
          <div class="card-body text-justify">
            <h5>Fee Structure for the Session 2024-25</h5>
            <hr class="pb-1 rounded">
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th scope="col">Classes</th>
                  <th scope="col">Toddler’s Club</th>
                  <th scope="col">Nursery, LKG & UKG</th>
                  <th scope="col">I to V</th>
                  <th scope="col">VI to VIII</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">Admission Fee only for new students</th>
                  <td>5000</td>
                  <td>5000</td>
                  <td>5000</td>
                  <td>5000</td>
                </tr>
                <tr>
                  <th scope="row">Tution Fee(2024-25)</th>
                  <td>2500</td>
                  <td>2750</td>
                  <td>3300</td>
                  <td>3650</td>
                </tr>

              </tbody>
            </table>

          </div>
          <h4 class="card-title">Maharana Pratap School, Sector-30, Kurukshetra</h4>
          <div class="card-body text-justify">
            <h5>Fee Structure for the Session 2024-25</h5>
            <hr class="pb-1 rounded">
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th scope="col">Classes</th>
                  <th scope="col">Nursery, LKG & UKG</th>
                  <th scope="col">I to V</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">Admission Fee only for new students</th>
                  <td>7000</td>
                  <td>7000</td>
                </tr>
                <tr>
                  <th scope="row">Tuition Fee (2024-25)</th>
                  <td>2950</td>
                  <td>3550</td>
                </tr>

              </tbody>
            </table>

          </div> -->
        </div>

      </div>
    </div>


  </div>
</div>